var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('form', {
    attrs: {
      "accept-charset": "UTF-8",
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage),
      expression: "successMessage"
    }],
    staticClass: "alert alert-success"
  }, [_vm._v("\n      " + _vm._s(_vm.successMessage) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPassword),
      expression: "currentPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "currentPassword",
      "placeholder": "current password",
      "type": "password",
      "min": "6",
      "data-vv-as": "current password",
      "disabled": _vm.disableAllInputs
    },
    domProps: {
      "value": (_vm.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validate_errors.has('currentPassword')),
      expression: "validate_errors.has('currentPassword')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.validate_errors.first('currentPassword')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|contains_alpha_lower|contains_alpha_upper|contains_number'),
      expression: "'required|min:8|contains_alpha_lower|contains_alpha_upper|contains_number'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newPassword",
      "placeholder": "new password",
      "type": "password",
      "min": "8",
      "data-vv-as": "new password",
      "disabled": _vm.disableAllInputs
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validate_errors.has('newPassword')),
      expression: "validate_errors.has('newPassword')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.validate_errors.first('newPassword')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPasswordConfirmation),
      expression: "newPasswordConfirmation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:newPassword'),
      expression: "'required|confirmed:newPassword'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newPasswordConfirmation",
      "placeholder": "confirm password",
      "type": "password",
      "min": "8",
      "data-vv-as": "confirm password",
      "disabled": _vm.disableAllInputs
    },
    domProps: {
      "value": (_vm.newPasswordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPasswordConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validate_errors.has('newPasswordConfirmation')),
      expression: "validate_errors.has('newPasswordConfirmation')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.validate_errors.first('newPasswordConfirmation')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group text-center"
  }, [_c('p', {
    staticClass: "text-muted mx-auto"
  }, [_vm._v(_vm._s(this.$passwordRequirements))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-6 text-sm-left text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "submit",
      "value": "Save New Password",
      "disabled": _vm.protectedUI || !_vm.formIsValid || _vm.disableAllInputs
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-sm-right text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Cancel")])], 1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-key"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb91382","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ChangePassword.vue
// module id = IWqs
// module chunks = 1